export default "__VITE_ASSET__db55f3c0__"